module.exports = __webpack_public_path__ + "img/HOME.11b4c938.svg";